"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requireStatus = void 0;
const create_error_1 = require("../create-error");
const error_interfaces_1 = require("../types/error.interfaces");
const http_interfaces_1 = require("../types/http.interfaces");
/**
 * Wraps HTTP sender so that good responses with statuses not matching
 * the required status are turned into errors.
 * The required status could be a mix of HTTP status numbers
 * and classes of HTTP status, like StatusXX.HTTP_2XX, Status.OK.
 */
function requireStatus(send, ...requiredStatus) {
    return (request) => send(request).then((response) => {
        if (isRequiredStatus(response.status, requiredStatus)) {
            return response;
        }
        const resultStatus = [http_interfaces_1.Status[response.status]];
        throw (0, create_error_1.createError)(error_interfaces_1.ErrorReason.RequireStatusFailed, response, resultStatus);
    });
}
exports.requireStatus = requireStatus;
const isRequiredStatus = (status, requiredStatus) => requiredStatus.indexOf(status) > -1 ||
    requiredStatus
        .filter(isStatusXX)
        .map((s) => new RegExp(s.replace(/x/gi, "\\d")))
        .some((r) => r.test(status.toString()));
function isStatusXX(s) {
    return typeof s === "string";
}
